export const SrednayaData = [
    {
        title: "дом №20",
        year: '1978',
        floor: "4",
        apartment: "56",
        quantityLC: "56",
        livingArea: "2658",
        notLivinigArea: "нет",
        commonProperty: "196,9",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "общедомовые приборы учета ХВС, ГВС, отопление",
        contractURL: 'srednaya/sofrino_srednaya_20_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    },

    {
        title: "дом №22",
        year: '1977',
        floor: "4",
        apartment: "56",
        quantityLC: "56",
        livingArea: "2664,5",
        notLivinigArea: "нет",
        commonProperty: "200,4",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжени",
        technicalSupport: "общедомовой прибор учета ХВС",
        contractURL: 'srednaya/sofrino_srednaya_22_dogovor.pdf',
        protocolURL: 'protocol_1E_2022-08-23.pdf',
    }

]